import React, { useEffect, useState } from "react";
import { Card, CardHeader, Box, Divider, CardContent, Grid } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import WorkIcon from "@mui/icons-material/Work";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import StatsCard from "../../Components/Cards/StatsCard";
import WSChart from "../../Components/Chart/WSChart";
import WSGoogleChart from "../../Components/Chart/WSGoogleChart";
import { callAPI, Method } from "../../commonFunctions/CommonFunctions";
import Chart from "react-google-charts";
import { getChartData, getPieChartData } from "./ChartFunctions";
import { WSIcons } from "../../commonFunctions/iIcons";
import { useNavigate } from "react-router-dom";
import WSBigCalander from "../../Components/WSBigCalander/WSBigCalander";
import { MyTaskList } from "./MyTasks";
// import { Calendar, momentLocalizer } from "react-big-calendar";
// import 'react-big-calendar/lib/css/react-big-calendar.css';
// import FullCalendar from "@fullcalendar/react";
// import dayGridPlugin from "@fullcalendar/daygrid";
// import interactionPlugin from "@fullcalendar/interaction";
// import moment from "moment";

interface ILeadInfo {
    leadCount: 0, leadPercentage: 0, newLeadCount: 0, newLeadPercentage: 0, closedLeads: 0, closedLeadsPercentage: 0, contactCount: 0, contactPercentage: 0, qualifiedCount: 0, qualifiedPercentage: 0
}
interface Lead {
    createdAt: string;
    status: string | null;
}
const DashboardOverview: React.FC<any> = React.memo((prpos) => {
    const [leadInfo, setLeadInfo] = useState<ILeadInfo>({ leadCount: 0, newLeadCount: 0, leadPercentage: 0, newLeadPercentage: 0, closedLeads: 0, closedLeadsPercentage: 0, contactCount: 0, contactPercentage: 0, qualifiedCount: 0, qualifiedPercentage: 0 })
    const [chartDataLeads, setChartDataLeads] = useState<any>()
    const [pieChartData, setPieChartData] = useState<any>()
    const navigate = useNavigate();
    useEffect(() => {

        async function getLeadsData() {
            try {
                const response: any = await callAPI('leads', Method.GET)
                if (response) {
                    const leads: any = response;
                    const totalLeads = leads.length;
                    const leadsCount = leads.filter((l: any) => l.leadType === 0).length;

                    const openLeads = leads.filter((l: any) => l.status === 'Lead Created' && l.leadType === 0).length;
                    const closedLeads = leads.filter((l: any) => l.status === 'Closed').length;
                    const contacts = leads.filter((l: any) => l.leadType === 1).length;
                    const contactsQualified = leads.filter((l: any) => l.leadType === 1 && l.status === 'Qualified').length;
                    const percentages: any = {
                        leadPercentage: totalLeads > 0 ? ((leadsCount / totalLeads) * 100).toFixed(2) : "0.00",
                        newLeadPercentage: totalLeads > 0 ? ((openLeads / totalLeads) * 100).toFixed(2) : "0.00",
                        closedPercentage: totalLeads > 0 ? ((closedLeads / totalLeads) * 100).toFixed(2) : "0.00",
                        contactsPercentage: totalLeads > 0 ? ((contacts / totalLeads) * 100).toFixed(2) : "0.00",
                        contactsQualifiedPercentages: totalLeads > 0 ? ((contactsQualified / totalLeads) * 100).toFixed(2) : "0.00",
                    };
                    setLeadInfo({
                        leadCount: leadsCount,
                        closedLeads: closedLeads,
                        newLeadCount: openLeads,
                        closedLeadsPercentage: percentages.closedPercentage,
                        newLeadPercentage: percentages.newLeadPercentage,
                        leadPercentage: percentages.leadPercentage,
                        contactCount: contacts,
                        contactPercentage: percentages.contactsPercentage,
                        qualifiedCount: contactsQualified,
                        qualifiedPercentage: percentages.contactsQualifiedPercentages
                    })
                    const chartData: any = getChartData(leads, 4);
                    const pieData = getPieChartData(leads);
                    setChartDataLeads(chartData)
                    setPieChartData(pieData)
                }
            }

            catch (error) {
            }
        }
        getLeadsData()
    }, [])
    const options = {
        title: "Leads vs Contacts",
        hAxis: { title: "Month" },
        vAxis: { title: "Count" },
        isStacked: true, // optional, makes it stacked
    };
    const pieOptions = {
        title: "Leads by Status",
        pieHole: 0.4, // makes it a donut chart (optional)
        legend: { position: "right" },
        is3D: true
    };
    const handleNewClick = () => {
        const status: any = {
            "field": "status",
            "operator": "eq",
            "value": "Lead Created"
        }
        navigate('/leads/list', { state: { status } })
    }
    const handleLeadsClick = () => {
        navigate('/leads/list')
    }
    const handleContactsClick = () => {
        navigate('/contacts/list')
    }
    const handleContactQualifiedClick = () => {
        const status: any = {
            "field": "status",
            "operator": "eq",
            "value": "Qualified"
        }
        navigate('/contacts/list', { state: { status } })
    }

    // const localizer = momentLocalizer(moment);
    // const leaveEvents: any = [
    //     {
    //         title: "Annual Leave",
    //         start: new Date(2025, 7, 30), // Aug 30, 2025
    //         end: new Date(2025, 7, 30),
    //         allDay: true
    //     },
    //     {
    //         title: "Sick Leave",
    //         start: new Date(2025, 8, 2),
    //         end: new Date(2025, 8, 4),
    //         allDay: true
    //     }
    // ];
    // const events = [
    //     { title: "24", start: "2025-08-30" },
    //     { title: "67", start: "2025-08-30" },
    //     { title: "Sick Leave", start: "2025-09-02", end: "2025-09-04" },
    // ];

    return (<>
        <Card sx={{ borderRadius: 3, p: 1, mt: 0 }} >
            <CardHeader
                title="Dashboard Overview"
                // subheader="11 Jan, 2025"
                sx={{
                    "& .MuiCardHeader-title": { fontSize: "0.875rem", fontWeight: 600 },
                    "& .MuiCardHeader-subheader": { fontSize: "0.8rem" },
                }}
            />
            <Divider />

            <Box display="flex" gap={3} flexWrap="wrap" p={2}>
                <StatsCard
                    title="Total leads"
                    icon={<PeopleIcon sx={{ fontSize: "0.875rem" }} />}
                    value={leadInfo.leadCount}
                    percentage={leadInfo.leadPercentage}
                    onClick={handleLeadsClick}
                // color="#0a0a56"
                />
                <StatsCard
                    title="New leads"
                    icon={<WSIcons.Person sx={{ fontSize: "0.875rem" }} />}
                    value={leadInfo.newLeadCount}
                    percentage={leadInfo.newLeadPercentage}
                    onClick={handleNewClick}
                // color="#2e7d32"
                />
                <StatsCard
                    title="Contacts"
                    icon={<WSIcons.ContactsIcon sx={{ fontSize: "0.875rem" }} />}
                    value={leadInfo.contactCount}
                    percentage={leadInfo.contactPercentage}
                    onClick={handleContactsClick}
                //color="#ef6c00"
                />
                <StatsCard
                    title="Contacts Quailified"
                    icon={<DoneAllIcon sx={{ fontSize: "0.875rem" }} />}
                    value={leadInfo.qualifiedCount}
                    percentage={leadInfo.qualifiedPercentage}
                    onClick={handleContactQualifiedClick}
                //color="#c62828"
                />
                {/* <StatsCard
                    title="Closed leads"
                    icon={<DoneAllIcon sx={{ fontSize: "0.875rem" }} />}
                    value={leadInfo.closedLeads}
                    percentage={leadInfo.closedLeadsPercentage}
                //color="#c62828"
                /> */}
            </Box>

        </Card>
        <Grid item container spacing={2} mt={0}>
            <Grid item sm={7} >
                {/* <Card sx={{ borderRadius: 3, p: 1 }}>
                    <CardHeader
                        title="Dashboard Overview"
                        // subheader="11 Jan, 2025"
                        sx={{
                            "& .MuiCardHeader-title": { fontSize: "1rem", fontWeight: 600 },
                            "& .MuiCardHeader-subheader": { fontSize: "0.8rem" },
                        }}
                    /> */}
                {/* <Divider /> */}
                {/* <CardContent> */}
                <Card sx={{ borderRadius: 3 }}>
                    <Chart
                        chartType="AreaChart"
                        width="100%"
                        height="auto"
                        style={{ minHeight: '300px', }}
                        data={chartDataLeads}
                        options={{
                            ...options,
                            //chartArea: { width: "80%", height: "70%" }, // keep chart neat
                            legend: { position: "bottom" },
                        }}
                    /></Card>
                {/* <WSGoogleChart
                    type="area"
                    title="Leads"
                    data={chartData}
                    xData={["Leads", "Contacts"]}
                /> */}
                {/* </CardContent> */}
                {/* </Card> */}
            </Grid>
            <Grid item sm={5}>
                <Card sx={{ borderRadius: 3 }}>
                    <Chart
                        chartType="PieChart"
                        width="100%"
                        height="300px"
                        data={pieChartData}
                        options={pieOptions}
                    />
                </Card>
            </Grid>
            <Grid item sm={6}>
                <MyTaskList title="My Tasks" transForm={true} />
            </Grid>
            <Grid item sm={6}>
                <MyTaskList title="All Tasks" />
            </Grid>
        </Grid>
    </>
    );
});

export default DashboardOverview;
